import { useQueryClient } from '@tanstack/react-query'
import { useFocusEffect, useLocalSearchParams } from 'expo-router'
import { useCallback, useState } from 'react'

import { useReschedulePatientAppointment } from '@/api/hooks/useReschedulePatientAppointment'
import { ReschedulePerioConfirmation } from '@/components/ReschedulePerioModal/ReschedulePerioConfirmation'
import { ReschedulePerioConfirmed } from '@/components/ReschedulePerioModal/ReschedulePerioConfirmed'

export default function ReschedulePerioAppointmentModal() {
	const queryClient = useQueryClient()
	const [hasCancelledAppointment, setHasCancelledAppointment] = useState(false)
	const { appointmentId } = useLocalSearchParams<{ appointmentId: string }>()
	const { mutate: rescheduleAppointment, isPending: isCancellingAppointment } =
		useReschedulePatientAppointment()

	const onConfirmCancelPress = () => {
		rescheduleAppointment(
			{ appointmentId: Number(appointmentId) },
			{
				onSuccess: () => {
					setHasCancelledAppointment(true)
				},
			}
		)
	}

	useFocusEffect(
		useCallback(() => {
			return () => {
				queryClient.invalidateQueries({
					queryKey: ['upcoming-appointment'],
				})
			}
		}, [queryClient.invalidateQueries])
	)

	return !hasCancelledAppointment ? (
		<ReschedulePerioConfirmation
			isCancellingAppointment={isCancellingAppointment}
			onConfirmPressed={onConfirmCancelPress}
		/>
	) : (
		<ReschedulePerioConfirmed />
	)
}
